import { h } from './index-16457198.js';
import { c as clsx } from './clsx.m-3c237499.js';

const InternalRadioButton = ({ name, nesId, checked, disabled, border, label, helpText, onChange, onClick, tabIndex, value, loading, standalone, hiddenLabel, }) => (h("div", { class: "nes-radioButton" },
  h("input", { id: nesId, name: name, type: "radio", value: value, checked: checked, class: clsx("nes-radioButton__input", {
      "is-loading": loading,
    }), disabled: loading || disabled, onChange: onChange, onClick: onClick, tabIndex: tabIndex ? tabIndex : undefined }),
  h("div", { class: "nes-radioButton__text" },
    h("label", { htmlFor: nesId, class: clsx("nes-radioButton__label", {
        "nes-radioButton__label--border": border,
        "nes-radioButton__label--standalone": standalone,
      }), tabIndex: -1 },
      h("span", { class: clsx({
          "nes-sr-only": hiddenLabel,
        }) }, label),
      helpText && h("nes-help-text", null, helpText)))));

export { InternalRadioButton as I };
